module.exports = __webpack_public_path__ + "static/media/Rates.45938527.svg";